/* Layout */
import Layout from '@/views/layout/Layout';
import publishApp from '@/views/generalUser/publishApp/index';
import AppDetail from '@/views/generalUser/publishApp/appDetail';
const publishAppRouter = {
  path: '/manage/publish',
  name: 'warning',
  props: true,
  meta: {
    title: '上架应用',
    icon: 'myApp-shelf',
    requiresAuth: true,
    role: 'seller',
    perms: ['User.Market.Application.Get']
  },
  hidden: false,
  component: Layout,
  children: [
    {
      path: 'info',
      name: 'publishApp',
      component: publishApp,
      meta: {
        title: '上架应用',
        icon: 'myApp-shelf',
        requiresAuth: true,
        role: 'seller',
        perms: ['User.Market.Application.Get']
      }
    },
    {
      path: 'apps/:appID/:tabMode',
      name: 'publishAppManageDetails',
      component: AppDetail,
      meta: {
        title: '应用详情',
        icon: 'myApp-details',
        requiresAuth: true,
        role: 'seller',
        currentActive: '/manage/publish/apps',
        perms: ['User.Market.Application.Get']
      },
      hidden: true
    }
  ]
};
export default publishAppRouter



// WEBPACK FOOTER //
// ./src/router/modules/publishApp.js